import {
  IconComponent,
  NumberCircleFiveIcon,
  NumberCircleFourIcon,
  NumberCircleOneIcon,
  NumberCircleThreeIcon,
  NumberCircleTwoIcon,
} from '@fronton/icons-react';
import { ADPLATFORM_TRAINING_CDN_PATH } from '../../adplatform-training-constants';

type AdplatformTrainingWebinarPointStructure = {
  icon: IconComponent;
  text: string;
};

export type AdplatformTrainingWebinarStructure = {
  name: string;
  videoSrc: string;
  image: {
    srcLd: string;
    srcD: string;
    srcT: string;
    srcM: string;
    alt: string;
  };
  points: AdplatformTrainingWebinarPointStructure[];
};

export const ADPLATFORM_TRAINING_WEBINARS_DATA: AdplatformTrainingWebinarStructure[] = [
  {
    name: 'Как расти круглый год и удерживать интерес к бренду',
    videoSrc:
      'https://storage.yandexcloud.net/lemanapro-ru-landings-docs/Monetasion/grow-year-round-and-maintain-brand-interest_webinar.mp4',
    image: {
      srcLd: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/grow-year-round-and-maintain-brand-interest_webinar-ld.jpg/grow-year-round-and-maintain-brand-interest_webinar-ld.jpg`,
      srcD: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/grow-year-round-and-maintain-brand-interest_webinar-d.jpg/grow-year-round-and-maintain-brand-interest_webinar-d.jpg`,
      srcT: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/grow-year-round-and-maintain-brand-interest_webinar-t.jpg/grow-year-round-and-maintain-brand-interest_webinar-t.jpg`,
      srcM: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/grow-year-round-and-maintain-brand-interest_webinar-m.jpg/grow-year-round-and-maintain-brand-interest_webinar-m.jpg`,
      alt: 'Смотреть видео как расти круглый год и удерживать интерес к бренду',
    },
    points: [
      {
        icon: NumberCircleOneIcon,
        text: 'Особенности поведения покупателей товаров DIY',
      },
      {
        icon: NumberCircleTwoIcon,
        text: 'Как грамотно распределить маркетинговый бюджет на\u00A0год',
      },
      {
        icon: NumberCircleThreeIcon,
        text: 'Стратегии продвижения в\u00A0пики продаж и\u00A0межсезонье',
      },
    ],
  },
  {
    name: 'Стратегия роста онлайн и офлайн: как продавать вместе, а не вместо',
    videoSrc:
      'https://storage.yandexcloud.net/lemanapro-ru-landings-docs/Monetasion/online-and-offline-growth-strategy_webinar.mp4',
    image: {
      srcLd: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/online-and-offline-growth-strategy_webinar-ld.jpg/online-and-offline-growth-strategy_webinar-ld.jpg`,
      srcD: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/online-and-offline-growth-strategy_webinar-d.jpg/online-and-offline-growth-strategy_webinar-d.jpg`,
      srcT: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/online-and-offline-growth-strategy_webinar-t.jpg/online-and-offline-growth-strategy_webinar-t.jpg`,
      srcM: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/online-and-offline-growth-strategy_webinar-m.jpg/online-and-offline-growth-strategy_webinar-m.jpg`,
      alt: 'Смотреть видео cтратегия роста онлайн и офлайн: как продавать вместе, а не вместо',
    },
    points: [
      {
        icon: NumberCircleOneIcon,
        text: 'Какие есть отчеты от\u00A0Лемана ПРО и\u00A0как их\u00A0анализировать',
      },
      {
        icon: NumberCircleTwoIcon,
        text: 'Как оценить вклад рекламы на\u00A0рост продаж офлайн и\u00A0онлайн и\u00A0найти точки роста',
      },
      {
        icon: NumberCircleThreeIcon,
        text: 'Как и\u00A0где размещать рекламу, чтобы увеличить GMV онлайн и\u00A0офлайн',
      },
    ],
  },
  {
    name: 'Медийная реклама на Лемана ПРО',
    videoSrc:
      'https://storage.yandexcloud.net/lemanapro-ru-landings-docs/Monetasion/mediynaya-reklama-na-lemana-pro_webinar.mp4',
    image: {
      srcLd: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/mediynaya-reklama-na-lemana-pro_webinar-ld.jpg/mediynaya-reklama-na-lemana-pro-ld-02.jpg`,
      srcD: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/mediynaya-reklama-na-lemana-pro_webinar-d.jpg/mediynaya-reklama-na-lemana-pro_webinar-d-02.jpg`,
      srcT: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/mediynaya-reklama-na-lemana-pro_webinar-t.jpg/mediynaya-reklama-na-lemana-pro_webinar-t-02.jpg`,
      srcM: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/mediynaya-reklama-na-lemana-pro_webinar-m.jpg/mediynaya-reklama-na-lemana-pro_webinar-m-02.jpg`,
      alt: 'Смотреть видео медийная реклама на Лемана ПРО',
    },
    points: [
      {
        icon: NumberCircleOneIcon,
        text: 'Как баннерная реклама помогает продавать',
      },
      {
        icon: NumberCircleTwoIcon,
        text: 'Лайфхаки для повышения эффективности рекламы',
      },
      {
        icon: NumberCircleThreeIcon,
        text: 'Настройка и\u00A0анализ кампании в\u00A0рекламном кабинете Лемана ПРО',
      },
      {
        icon: NumberCircleFourIcon,
        text: 'Ответим на вопросы',
      },
    ],
  },
  {
    name: 'Как выбрать форматы рекламы для продвижения',
    videoSrc:
      'https://storage.yandexcloud.net/lemanapro-ru-landings-docs/Monetasion/kak-vybrat-formaty-reklamy-dlya-prodvizheniya_webinar.mp4',
    image: {
      srcLd: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/kak-vybrat-formaty-reklamy-dlya-prodvizheniya_webinar-ld.jpg/kak-vybrat-formaty-reklamy-dlya-prodvizheniya_webinar-ld-01.jpg`,
      srcD: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/kak-vybrat-formaty-reklamy-dlya-prodvizheniya_webinar-d.jpg/kak-vybrat-formaty-reklamy-dlya-prodvizheniya_webinar-d-01.jpg`,
      srcT: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/kak-vybrat-formaty-reklamy-dlya-prodvizheniya_webinar-t.jpg/kak-vybrat-formaty-reklamy-dlya-prodvizheniya_webinar-t-01.jpg`,
      srcM: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/kak-vybrat-formaty-reklamy-dlya-prodvizheniya_webinar-m.jpg/kak-vybrat-formaty-reklamy-dlya-prodvizheniya_webinar-m-01.jpg`,
      alt: 'Смотреть видео как выбрать форматы рекламы для продвижения',
    },
    points: [
      {
        icon: NumberCircleOneIcon,
        text: 'Познакомим с\u00A0форматами рекламы и\u00A0их\u00A0особенностями',
      },
      {
        icon: NumberCircleTwoIcon,
        text: 'Расскажем, как выбрать эффективные форматы рекламы, исходя из\u00A0цели бизнеса',
      },
      {
        icon: NumberCircleThreeIcon,
        text: 'Поделимся тем, как рассчитать бюджет на\u00A0продвижение. Презентация прогнозатора Лемана ПРО',
      },
      {
        icon: NumberCircleFourIcon,
        text: 'Ответим на вопросы',
      },
    ],
  },
  {
    name: 'Как эффективно настроить рекламную кампанию',
    videoSrc:
      'https://storage.yandexcloud.net/lemanapro-ru-landings-docs/Monetasion/kak-ehffektivno-nastroit-kampaniyu_webinar.mp4',
    image: {
      srcLd: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/kak-ehffektivno-nastroit-kampaniyu_webinar-ld.jpg/kak-ehffektivno-nastroit-kampaniyu_webinar-ld.jpg`,
      srcD: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/kak-ehffektivno-nastroit-kampaniyu_webinar-d.jpg/kak-ehffektivno-nastroit-kampaniyu_webinar-d.jpg`,
      srcT: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/kak-ehffektivno-nastroit-kampaniyu_webinar-t.jpg/kak-ehffektivno-nastroit-kampaniyu_webinar-t.jpg`,
      srcM: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/kak-ehffektivno-nastroit-kampaniyu_webinar-m.jpg/kak-ehffektivno-nastroit-kampaniyu_webinar-m2.jpg`,
      alt: 'Смотреть видео как увеличить продажи в Лемана ПРО',
    },
    points: [
      {
        icon: NumberCircleOneIcon,
        text: 'Познакомим с\u00A0рекламными инструментами нашей площадки',
      },
      {
        icon: NumberCircleTwoIcon,
        text: 'Покажем пошаговый план для начала работ в\u00A0рекламном кабинете',
      },
      {
        icon: NumberCircleThreeIcon,
        text: 'Разберём основные ошибки при запуске рекламы',
      },
      {
        icon: NumberCircleFourIcon,
        text: 'Расскажем, как легко пройти модерацию',
      },
      {
        icon: NumberCircleFiveIcon,
        text: 'Поговорим про аналитику и\u00A0закрывающие документы',
      },
    ],
  },
  {
    name: 'Как увеличить продажи в Лемана ПРО',
    videoSrc:
      'https://storage.yandexcloud.net/lemanapro-ru-landings-docs/Monetasion/kak-uvelichit-prodazhi_webinar.mp4',
    image: {
      srcLd: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/kak-uvelichit-prodazhi-ld.jpg/kak-uvelichit-prodazhi-ld.jpg`,
      srcD: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/kak-uvelichit-prodazhi-d.jpg/kak-uvelichit-prodazhi-d.jpg`,
      srcT: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/kak-uvelichit-prodazhi-t.jpg/kak-uvelichit-prodazhi-t.jpg`,
      srcM: `${ADPLATFORM_TRAINING_CDN_PATH}/webinar/kak-uvelichit-prodazhi-m.jpg/kak-uvelichit-prodazhi-m2.jpg`,
      alt: 'Смотреть видео как увеличить продажи в Лемана ПРО',
    },
    points: [
      {
        icon: NumberCircleOneIcon,
        text: 'Расскажем про возможности нашей площадки',
      },
      {
        icon: NumberCircleTwoIcon,
        text: 'Поделимся советами по\u00A0запуску эффективной рекламы',
      },
      {
        icon: NumberCircleThreeIcon,
        text: 'Покажем пошаговый план для начала работ в\u00A0рекламном кабинете',
      },
      {
        icon: NumberCircleFourIcon,
        text: 'Наш поставщик поделится результатами рекламной кампании',
      },
      {
        icon: NumberCircleFiveIcon,
        text: 'Ответим на\u00A0часто задаваемые вопросы',
      },
    ],
  },
];
